import { CommonModule, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { matLink } from '@ng-icons/material-icons/baseline';
import { TranslateModule } from '@ngx-translate/core';
import { DebounceClickDirective } from '@shared/directives/debounce-click.directive';
import { RequireLoginDirective } from '@shared/directives/require-login.directive';
import { copyToClipboard } from '@shared/functions/text-copy';

@Component({
  selector: 'app-copy-text',
  templateUrl: './copy-text.component.html',
  imports: [
    NgIcon,
    RequireLoginDirective,
    DebounceClickDirective,
    NgbTooltipModule,
    NgTemplateOutlet,
    CommonModule,
    TranslateModule,
  ],
  viewProviders: [provideIcons({ matLink })],
})
export class CopyTextComponent {
  @Input() isLoginRequired = false;
  @Input() isUrlCopied = false;
  @Input() textToCopy = '';
  @Input() copyWithCondition = false;

  @Output() copyWithConditionClicked = new EventEmitter();
  copyUrl(): void {
    if (this.copyWithCondition) {
      this.copyWithConditionClicked.emit();
    } else {
      void copyToClipboard(this.textToCopy, () => {
        this.isUrlCopied = true;

        setTimeout(() => {
          this.isUrlCopied = false;
        }, 700);
      });
    }
  }
}
